export default function Health() {
  return <pre>OK {new Date().toISOString()}</pre>;
}
